import { reduxKey } from '../constants';
import reducers from './reducers';
import saga from './sagas';
import { reduxInitialized } from './actions/initialization';
export function getDamzModule() {
    return {
        id: 'damzModule',
        reducerMap: {
            [reduxKey]: reducers
        },
        initialActions: [
            reduxInitialized()
        ],
        sagas: [
            saga
        ],
        retained: true
    };
}

//# sourceMappingURL=module.js.map